import { IconMessage16 } from '@cian/ui-kit';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { NarrowCardMoreControlsItem } from '../../../../../components/desktop/NarrowCardMoreControlsItem';
import { ChatButtonRenderer } from '../../../../common/ChatButton';

export const MoreItemChatsContainer: FC = () => {
  const render = useCallback(
    ({ onClick }: { onClick: () => void }): JSX.Element => (
      <NarrowCardMoreControlsItem
        icon={<IconMessage16 />}
        title="Написать"
        onClick={(e: SyntheticEvent) => {
          e.stopPropagation();
          onClick();
        }}
      />
    ),
    [],
  );

  return <ChatButtonRenderer render={render} />;
};
